// Import from design system package
import {
  Sticker,
  StickerPriority,
  StickerVariant,
  StickerRootProps,
  StickerIconProps,
  StickerTextProps
} from "@packages/ds";

// Re-export the component parts for backward compatibility
// with `import * as Sticker from "ds/Sticker"`
export const Root = Sticker.Root;
export const Icon = Sticker.Icon;
export const Text = Sticker.Text;

// Re-export the enums with original names for backward compatibility
export type Priority = StickerPriority;
export type Variant = StickerVariant;

// Re-export the types with original names for backward compatibility
export type RootProps = StickerRootProps;
export type IconProps = StickerIconProps;
export type TextProps = StickerTextProps;

// Export default for backward compatibility with default imports
export default { Root, Icon, Text };
